export default __webpack_public_path__ + "static/media/Hubano-1Closed.0212ff4c.jpg";